import { Component } from '@angular/core';
import { MySkillAcknowledgementsConstants } from '../../constants/my-skill-acknowledgements.constants';
import { MySkillAcknowledgementsService } from '../../services/my-skill-acknowledgements.service';
import { LabelConstants } from '../../../shared/constants/label-constants';

@Component({
  selector: 'app-my-skill-acknowledgements',
  templateUrl: './my-skill-acknowledgements.component.html',
  styleUrls: ['./my-skill-acknowledgements.component.scss']
})
export class MySkillAcknowledgementsComponent {
  topBarTitle: string = MySkillAcknowledgementsConstants.MySkillAcknowledgement_TopBarTitle;
  showAllLabel: string = MySkillAcknowledgementsConstants.MySkillAcknowledgement_ShowAllLabel;
  isIncludeAll = MySkillAcknowledgementsConstants.MySkillAcknowledgement_IsIncludeAll;
  showInformationIconCheckbox = MySkillAcknowledgementsConstants.MySkillAcknowledgement_ShowInformationIconCheckbox;
  showAllToolTip: string = MySkillAcknowledgementsConstants.MySkillAcknowledgement_CheckBoxHoverToolTip;
  skillAcknowledgements: any[] = [];
  panelListType: string = MySkillAcknowledgementsConstants.MySkillAcknowledgement_PanelListType;
  showLoader: boolean = true;
  isScreenAccessible: boolean = true;
  errorMessage !: string;
  displayShowAllButton: boolean = true;
  displayShowAllLabel: boolean = true;

  constructor(private mySkillAcknowledgementsService: MySkillAcknowledgementsService) { }
  ngOnInit(): void {
    this.getSkillListData(this.isIncludeAll);
  }

  includeInactive(isIncludeAll: boolean) {
    this.getSkillListData(isIncludeAll);
  }

  getSkillListData(isIncludeAll: boolean, withDealy: boolean = false) {
    this.showLoader = true;
     if (withDealy) {
      setTimeout(() => this.fetchSkillListData(isIncludeAll), 3000);
    } else {
      this.fetchSkillListData(isIncludeAll);
    }
  }
   private fetchSkillListData(isIncludeAll: boolean) {
    this.mySkillAcknowledgementsService.getMySkillAcknowledgements(isIncludeAll).subscribe({
      error: (err) => {
        if (err.status === LabelConstants.Forbidden_StatusCode) {
          this.errorMessage = err.error.detail;
        }
        this.isScreenAccessible = false;
        this.showLoader = false;
      },
      next: (serviceData) => {
        this.skillAcknowledgements = serviceData;
        this.showLoader = false;
      }
    });
  }
}

